import { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AiFillAudio, AiFillPauseCircle } from "react-icons/ai";
import css from "./index.module.css";
import BreadCrumbNav from "../BreadCrumbNav/BreadCrumbNav";
import getHomePageUrl from "../../services/hooks/getHomePageUrl";
import NotificationIcon from "../Notification/NotificationIcon";
import ProfileSideBar from "./profileSideBar";
import { useLocation, useNavigate } from "react-router-dom";
import GlobalSearch from "../PortalDashboard/GlobalSearch";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import { getImageUrl } from "@Utils";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconComponent from "@CubeComponents/icons";
import { setHelpSectionState } from "@Actions/portalDashboard";
import { ThemeContext } from "../../ProviderApp";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import PortalUsers from "@Components/PortalSetings/UserAdminstration/PortalUsers/ListPortalUsers";
import { THEME_LIGHT } from "../../App.constant";
import TimerComponent from "@CubeComponents/dashboardComponents/TimerComponent";
import useDashboard from "@Components/PortalDashboard/helper";
import { handleUpgrageButtonClick } from "@Services/subscriptionHelper";
import _ from "lodash";

function Header({ hideSearch = false, hideNotification = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [homePageUrl] = getHomePageUrl();
  const [showSidebar, setShowSidebar] = useState(false);
  const { userDetails, helpSectionState, portalData, layout, onReduceHeader, portalDashboardData, userPermissions } =
    useSelector((state) => state);
  const [audioStart, setAudioStart] = useState(false);
  const [audioSuggestion, setAudioSuggestion] = useState("");
  const [recognitionHandler, setRecognitionHandler] = useState(null);
  const logoClick = () => {
    navigate(homePageUrl);
  };
  const location = useLocation();
  const themeContext = useContext(ThemeContext);
  const [permissionObj, setPermissionObj] = useState();

  const getProfile = (type) => {
    return <UserNameTagComponent showAvatarOnly id={userDetails._id} size={type} isCircle />;
  };

  const tempBlockForCpwd = ["techm-dev", "techm-prod", "techm-preprod"].includes(process.env.REACT_APP_ENV);
  const newPortalInactiveIllustration = portalData.isExpired && portalData.newSignUpFlow;

  const { getWeatherDiv, getDate } = useDashboard({
    portalData,
    portalLayout: layout,
    portalDashboardData,
    userDetails,
  });
  useEffect(() => {
    if (audioSuggestion) {
      const ifSearch = audioSuggestion.search(/search|find/);
      if (ifSearch != -1) {
        const query = audioSuggestion.replace("search", "").replace("find", "").replace("please", "").trim();
        navigate(`/search?query=${query}`);
      }
    }
  }, [audioSuggestion]);

  useEffect(() => {
    const portalPermissions = _.get(userPermissions, "RESOURCE_TYPE_PORTAL.permissions", []);
    if (portalPermissions.length) {
      const manageSubPermission = _.includes(portalPermissions, "MANAGE_PORTAL_SUBSCRIPTION");
      const inviteUserPermission = _.includes(portalPermissions, "USERS_ASSIGN_ROLE_TO_PROJECTS");
      setPermissionObj({
        manageSubPermission,
        inviteUserPermission,
      });
    }
  }, [userPermissions]);

  const handleAudioStart = () => {
    if (!("SpeechRecognition" in window || "webkitSpeechRecognition" in window)) {
      setAudioSuggestion("Your browser does not support this feature");
      return;
    }

    setAudioStart(true);
    window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new window.SpeechRecognition();

    recognition.interimResults = true;
    recognition.continuous = true;
    recognition.continuous = false;
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const result = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      setAudioSuggestion(result);
      setAudioStart(false);
    };

    recognition.onend = () => {
      setAudioStart(false);
    };

    recognition.onerror = () => {
      setAudioStart(false);
    };

    recognition.onnomatch = () => {
      setAudioStart(false);
    };

    recognition.start();
    setRecognitionHandler(recognition);
  };

  const handleAudioStop = () => {
    setAudioStart(false);
    recognitionHandler.stop();
  };

  const handleClose = () => {
    setShowSidebar(false);
  };

  const [showPortalUsers, setShowPortalUsers] = useState(false);

  const handleManageUsersButtonClick = () => {
    setShowPortalUsers(true);
  };

  const millisecondsToDays = (milliseconds) => {
    const days = milliseconds / (1000 * 60 * 60 * 24);
    return Math.ceil(days);
  };

  const handleHelpSectionClick = () => {
    dispatch(setHelpSectionState(!helpSectionState));
  };
  const renderTrialData = () => {
    if (portalData.expiredState == "LIVE_TRIAL") {
      const daysLeft = millisecondsToDays(portalData.subscription.subExpiresOn - Date.now());
      return (
        <div className="flex items-center gap-5">
          {t("daysCountInTrial", { count: daysLeft })}
          <div className="flex gap-5">
            <ButtonComponent
              onClick={handleUpgrageButtonClick({ portalData, userDetails })}
              buttonType={"gradientButton"}
              startIcon={<IconComponent name="Stars" />}
              className={`${permissionObj?.manageSubPermission ? "block" : "hidden"}`}
            >
              {t("Upgrade")}
            </ButtonComponent>
            <ButtonComponent
              onClick={handleManageUsersButtonClick}
              buttonType={"borderButton"}
              className={`${permissionObj?.inviteUserPermission ? "block" : "hidden"}`}
            >
              {t("Manage Users")}
            </ButtonComponent>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  const projectHeader = () => (
    <div className={`${css.root} ${css.headerWrapper} w-full`}>
      <div className="flex h-full items-center">
        <div className={`${css.logoBox} ${css.headerElement}`}>
          {Object.keys(layout).length ? (
            <img
              style={{ cursor: "pointer" }}
              onClick={logoClick}
              className={css.logo}
              src={
                layout.ALLOW_PORTAL_LOGO_UPDATE && portalData.logo
                  ? portalData.logoUrl
                  : getImageUrl() + layout.HEADER_LOGO
              }
              alt="Logo"
            />
          ) : null}
        </div>
        <div className={css.breadCrumbWrapper}>
          <BreadCrumbNav />
        </div>
      </div>
      <div className="flex items-center h-full">
        <AppBar color="default" sx={{ background: "#f0f5f9", boxShadow: "none", zIndex: 10, display: "contents" }}>
          <Toolbar
            sx={{
              alignItems: "center",
              gap: "20px",
              width: "100%",
              justifyContent: "end",
            }}
          >
            {renderTrialData()}
            {["qa", "development"].includes(process.env.REACT_APP_ENV) ? (
              <div className="audioAi" data-testid="audioAI">
                <div className="suggestions" style={{ position: "relative" }}>
                  <span className={css.suggestion}>{audioSuggestion}</span>
                </div>
                {audioStart == false && (
                  <AiFillAudio style={{ cursor: "pointer" }} size={18} color="red" onClick={handleAudioStart} />
                )}
                {audioStart == true && (
                  <AiFillPauseCircle style={{ cursor: "pointer" }} size={18} color="red" onClick={handleAudioStop} />
                )}
              </div>
            ) : null}
            {layout.SHOW_GLOBAL_SEARCH && !hideSearch && <GlobalSearch />}
            {!hideNotification && <NotificationIcon />}
            <IconComponent onClick={handleHelpSectionClick} showGradient={helpSectionState} name="help" />
            <IconButton
              className="cursor-pointer p-0"
              data-testid="avatarInitialsSmallIcon"
              onClick={() => setShowSidebar((prev) => !prev)}
            >
              {getProfile("XS")}
            </IconButton>
          </Toolbar>
        </AppBar>
      </div>
    </div>
  );

  const portalHeader = () => (
    <div className={`flex items-center ${!onReduceHeader ? "h-18" : "h-48"}`}>
      <AppBar
        color="default"
        sx={{
          background: themeContext.themeType === THEME_LIGHT ? "#f0f5f9" : "#1e1e1e",
          boxShadow: "none",
          zIndex: 10,
          display: "contents",
          // paddingInlineEnd: "40px",
          // paddingInlineStart: "40px",
        }}
      >
        <div className="w-full flex h-full flex-col pe-10 ps-10">
          <Toolbar
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
            }}
          >
            {!onReduceHeader && (
              <div className="flex items-center w-full gap-2" data-testid="portalDashboardLogo">
                <img
                  alt="Logo"
                  className="w-10 h-10"
                  src={
                    layout.ALLOW_PORTAL_LOGO_UPDATE && portalData.logo
                      ? portalData.logoUrl
                      : getImageUrl() + layout.HEADER_LOGO
                  }
                />
                <div data-testid="portalDashboardName" className="font-semibold text-xl">
                  {portalData.name}
                </div>
              </div>
            )}

            <div className="flex items-center w-full justify-end">
              <div className="cursor-auto"></div>
              {newPortalInactiveIllustration ? (
                <>
                  <ButtonComponent onClick={handleManageUsersButtonClick} buttonType={"borderButton"}>
                    {t("Manage Users")}
                  </ButtonComponent>
                  <ButtonComponent
                    className="me-2"
                    onClick={handleUpgrageButtonClick({ portalData, userDetails })}
                    buttonType={"gradientButton"}
                  >
                    {t("Upgrade")}
                  </ButtonComponent>
                </>
              ) : (
                <div className="flex items-center gap-8 justify-end w-full">
                  {renderTrialData()}
                  {!["prod"].includes(process.env.REACT_APP_ENV) && <GlobalSearch />}
                  <NotificationIcon />
                  <IconComponent onClick={handleHelpSectionClick} showGradient={helpSectionState} name="help" />
                  <IconButton className="cursor-auto p-0" onClick={() => setShowSidebar((prev) => !prev)}>
                    {getProfile("SM")}
                  </IconButton>
                </div>
              )}
            </div>
          </Toolbar>

          {onReduceHeader && (
            <Toolbar
              sx={{
                justifyContent: "space-between",
                border: "none",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
              }}
            >
              <div className="flex w-full items-center justify-between">
                <div className="flex items-center gap-2" data-testid="portalDashboardLogo">
                  <img
                    alt="Logo"
                    className="h-14"
                    src={
                      layout.ALLOW_PORTAL_LOGO_UPDATE && portalData.logo
                        ? portalData.logoUrl
                        : getImageUrl() + layout.HEADER_LOGO
                    }
                  />
                  <div className="flex flex-col">
                    <div className="font-semibold text-xl" data-testid="portalDashboardName">
                      {portalData.name}
                    </div>
                    <span className="text-4xl flex gap-1 font-bold" data-testid="portalDashboardWelcomeText">
                      {" "}
                      {`${layout.WELCOME_TEXT}, ${userDetails.firstName} ${userDetails.lastName} `}
                      <IconComponent name="hiIcon" className="h-10" />
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-5">
                  <div className="flex items-center justify-center gap-4">
                    <IconComponent name="Calendar" className="h-9" />
                    <div className="flex flex-col">
                      <span className="font-bold text-xl" data-testid="portalDashboardDate">
                        {getDate().date}
                      </span>
                      <span data-testid="portalDashboardDay">{getDate().day}</span>
                    </div>
                  </div>
                  <div className="flex gap-2 items-center" data-testid="portalDashboardTime">
                    <TimerComponent />
                  </div>
                  {!tempBlockForCpwd && getWeatherDiv()}
                </div>
              </div>
            </Toolbar>
          )}
        </div>
      </AppBar>
    </div>
  );
  return (
    <>
      {showSidebar === true && <ProfileSideBar handleClose={handleClose} />}
      {location.pathname == "/dashboard" ? portalHeader() : projectHeader()}
      <ModalStateDialogComponent
        width="70%"
        allowModalPadding={true}
        headerTitle="Portal Users"
        onCancel={() => setShowPortalUsers(false)}
        modelContent={
          <div className="h-110 w-full flex overflow-auto">
            <PortalUsers disableHeaderText />
          </div>
        }
        isVisible={showPortalUsers}
      />
    </>
  );
}

export default Header;
